"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCategory = void 0;
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _reactRouterDom = require("react-router-dom");
const useCategory = ()=>{
    const { tenant } = (0, _environment.useEnvironment)();
    const { categoryName = '' } = (0, _reactRouterDom.useParams)();
    const { data, error } = (0, _globalApiClientReact.useGetApplicationsSupportCenterCategory)(categoryName, {
        [_fetching.TENANT_CONTEXT]: tenant
    }, {
        swr: {
            enabled: !!categoryName
        }
    });
    const loading = data === undefined && error === undefined;
    return {
        categoryName,
        data,
        loading,
        // @ts-expect-error -- Missing title in data type
        title: Object.keys(data !== null && data !== void 0 ? data : {}).includes('title') ? data.title : ''
    };
};
exports.useCategory = useCategory;
